import { useAuth0 } from "@auth0/auth0-react";
import { getAccessToken } from "../Session.queries";
import { useQuery } from "@tanstack/react-query";
import { SESSION_GC_TIME, SESSION_STALE_TIME } from "./Session.constants";

export function useToken() {
    const auth0Session = useAuth0();

    const token = useQuery<string>({
        ...getAccessToken(auth0Session),
        enabled:
            auth0Session.isAuthenticated &&
            !!auth0Session.getAccessTokenSilently,
        refetchOnWindowFocus: true,
        staleTime: SESSION_STALE_TIME,
        gcTime: SESSION_GC_TIME,
    });

    return token;
}
